export enum EInfractionType {
    IT_IDLING = 'IT_IDLING',
    IT_IDLING_AC = 'IT_IDLING_AC',
    IT_RPM = 'IT_RPM',
    IT_KICKDOWN = 'IT_KICKDOWN',
    IT_SPEED = 'IT_SPEED',
    IT_ACCELERATION = 'IT_ACCELERATION',
    IT_BRAKING = 'IT_BRAKING',
    IT_CLUTCH = 'IT_CLUTCH',
}

export interface INavigationTip {
    id: string;
    infractionType: EInfractionType;
    description: string;
    text: string;
    videoLink: string;
}

export const infractionTypeOptions = [
    { label: 'Selecione...', value: '' },
    { label: 'Excesso de marcha lenta', value: EInfractionType.IT_IDLING },
    { label: 'Excesso de marcha lenta + ar condicionado', value: EInfractionType.IT_IDLING_AC },
    { label: 'Excesso de RPM', value: EInfractionType.IT_RPM },
    { label: 'Arrancada', value: EInfractionType.IT_KICKDOWN },
    { label: 'Excesso de velocidade', value: EInfractionType.IT_SPEED },
    { label: 'Aceleração brusca', value: EInfractionType.IT_ACCELERATION },
    { label: 'Freada brusca', value: EInfractionType.IT_BRAKING },
    { label: 'Embreagem', value: EInfractionType.IT_CLUTCH },
];

